import React from 'react'

import { useHistory } from 'react-router-dom'

import queryString from 'query-string'

import { Modal, Button, Row, Col } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

const FormatoComprasModal = ({ handleClose, show, origen }) => {
  const history = useHistory()

  const clickCanjeGuias = React.useCallback(() => {
    const queryParams = queryString.stringify({
      origen: origen,
      formato: 'canje-guias'
    })

    history.push(`/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_NUEVO}?${queryParams}`)
  }, [history, origen])

  const clickIngresoLibre = React.useCallback(() => {
    const queryParams = queryString.stringify({
      origen: origen
    })

    history.push(`/${CodigosTransaccionesConstant.ASIENTOSCONTABLESORIGENDIARIO_NUEVO}?${queryParams}`)
  }, [history, origen])

  return (
    <Modal show={show} size='sm'>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Button color='primary' tiny onClick={clickCanjeGuias} block>
              Canje de Guías
            </Button>
          </Col>
          <Col md={6}>
            <Button color='primary' tiny onClick={clickIngresoLibre} block>
              Ingreso libre
            </Button>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} outline>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(FormatoComprasModal)
